export enum EventPowerUpId {
  Crew = 'crew',
  Zones = 'zones',
  SelfPrinting = 'selfPrinting',
  Dct = 'dct',
  Det = 'det',
  EventApps = 'eventApps',
  InvitationTracker = 'invitationTracker'
}
